import React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import FAQSchema from './FAQSchema';

const FAQSection: React.FC = () => {
  const faqs = [
    {
      question: "What should I expect during my first acupuncture session?",
      answer: "During your first session, your practitioner will discuss your health history, perform an assessment, and create a personalised treatment plan. The session will include gentle acupuncture tailored to your needs. You may also receive lifestyle or dietary guidance based on Chinese medicine principles."
    },
    {
      question: "Does acupuncture hurt?",
      answer: "Acupuncture is generally painless. You may feel a slight sensation when the needles are inserted, such as a tingling or dull ache, but most people find the experience deeply relaxing and calming."
    },
    {
      question: "How many sessions will I need?",
      answer: "The number of sessions depends on your individual health concerns and goals. Your practitioner will recommend a personalised treatment plan during your initial consultation. Acute conditions may respond quickly, while chronic or complex concerns may require ongoing care."
    },
    {
      question: "Can I claim acupuncture on my health insurance?",
      answer: "Many Australian private health funds cover acupuncture treatments provided by registered practitioners. Please check with your provider to confirm your level of cover and bring your membership card to your appointment."
    },
    {
      question: "What conditions can acupuncture help with?",
      answer: "Acupuncture can support a wide range of conditions, including hormonal imbalances, painful or irregular periods, fertility, pregnancy support, postpartum recovery, perimenopause, stress, anxiety, insomnia, digestive health, men's health, and general wellness. We serve clients across Caloundra, Pelican Waters, Birtinya, Kawana, and Mooloolaba."
    },
    {
      question: "Do you offer acupuncture for fertility and preconception care?",
      answer: "Yes. At Women and the Way, we specialise in fertility support and preconception planning for all people on the fertility journey. We provide acupuncture, herbal medicine, and lifestyle guidance tailored to your cycle and goals, including support for natural conception and IVF preparation. Our fertility services are available to clients throughout the Sunshine Coast, especially in areas like Caloundra and surrounding suburbs."
    },
    {
      question: "Can acupuncture help during pregnancy?",
      answer: "Yes. Acupuncture is a safe and effective support during pregnancy. It can help manage nausea, fatigue, back pain, emotional changes, and preparation for labour. We also offer postpartum care to support recovery and hormonal balance. Clients from Caloundra to Mooloolaba often seek us out for pregnancy-related care."
    },
    {
      question: "Are Chinese herbs part of the treatment plan?",
      answer: "Chinese herbal medicine may be recommended as part of your individualised plan. We use high-quality granule herbs and ensure they are suitable for your constitution, stage of life, and any other medications you may be taking."
    },
    {
      question: "What should I wear to my acupuncture session?",
      answer: "Wear loose, comfortable clothing that allows easy access to your lower arms, lower legs, and abdomen if needed. You may be asked to de-robe if necessary for effective treatment, but your comfort and privacy will always be respected with appropriate draping provided."
    },
    {
      question: "Can acupuncture help with stress and emotional wellbeing?",
      answer: "Absolutely. Acupuncture is well-known for supporting emotional health, reducing stress and anxiety, improving sleep, and calming the nervous system. Many clients report feeling relaxed and clear-headed after their sessions."
    },
    {
      question: "Do you treat people of all genders and life stages?",
      answer: "Yes. While our name reflects our special interest in women's health, our clinic welcomes people of all genders and ages. We support hormonal health across all life stages - from adolescence through to menopause and andropause, including care tailored for men's reproductive, hormonal and emotional health."
    }
  ];
  

  return (
    <>
      <FAQSchema items={faqs} />
      <section id="faq" className="section-padding bg-sage-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="mb-4 bg-gradient-to-r from-sage-600 to-amber-500 bg-clip-text text-transparent">Frequently Asked Questions</h2>
          <p className="max-w-3xl mx-auto text-lg text-gray-700">
            Have questions? We've got answers to help you feel confident and informed.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4 max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`faq-${index}`} className="bg-white rounded-xl border-2 border-amber-200/50 shadow-sm hover:shadow-md transition-shadow">
              <AccordionTrigger className="text-lg font-medium text-sage-800 px-6 py-4 text-left hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-700 px-6 pb-6 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Contact Button */}
        <div className="mt-12 text-center">
          <Button
            className="bg-sage-600 hover:bg-sage-400 text-white px-6 py-3 rounded-full shadow-md transition-all border-4 border-amber-400/30"
            asChild
          >
            <a href="#contact">Contact Us for More Information</a>
          </Button>
        </div>
      </div>
    </section>
    </>
  );
};

export default FAQSection;